<template>
  <section class="case-bottom-wrapper">
    <div class="container">
      <div class="title">
        Build Your <br />
        Partnership <br />
        With Us
      </div>

      <div class="action-panel">
        <base-button class="base-button" primary="dark" @click="onTouched"
          >GET IN TOUCH</base-button
        >
        <div v-if="showLink" class="link-btn" @click="toCases">SEE CASES</div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import BaseButton from "@/components/BaseButton.vue";

export default {
  name: "CaseBottom",
  props: {
    showLink: {
      type: [Boolean],
      default: false
    }
  },
  components: {
    BaseButton
  },
  computed: {
    ...mapState({
      open: state => state.isZendeskOpened
    })
  },
  methods: {
    ...mapActions(["toggleZendesk"]),
    onTouched() {
      this.toggleZendesk(!this.open);
    },
    toCases() {
      this.$router.push("/cases");
    }
  }
};
</script>

<style scoped lang="scss">
.case-bottom-wrapper {
  display: flex;

  .container {
    padding-left: 3.75rem;
    width: 100%;
    height: 45.625rem;
    position: relative;
    overflow: hidden;
    .title {
      font-size: 4.9375rem;
      font-weight: 600;
      line-height: 1.2;
      color: colors(dark);

      margin-bottom: 5.625rem;
    }

    .action-panel {
      display: flex;
      align-items: center;

      .base-button {
        width: 15.75rem;
      }
      .link-btn {
        @include fontSize(small);
        margin-left: 2.5rem;
        cursor: pointer;
        text-decoration: underline;
        font-weight: 500;
      }
    }

    &::after {
      content: "";
      width: 59.8125rem;
      height: 100%;
      pointer-events: none;
      background: url("../assets/img/cases/partnership-artwork.png") no-repeat
        50% 50%;
      background-size: contain;
      margin: auto;
      position: absolute;
      right: -5rem;
      top: 0;
    }
  }
}
</style>
